export const INVOICE_GROUPING_TYPES = {
    ONE_PER_SHIPMENT: 'ONE_PER_SHIPMENT',
    ONE_PER_SHIPMENT_PER_CHARGE_TYPE: 'ONE_PER_SHIPMENT_PER_CHARGE_TYPE',
    TWO_PER_SHIPMENT: 'TWO_PER_SHIPMENT',
    UNLIMITED: 'UNLIMITED',
};
